import { Button, Popover } from "@xola/ui-kit";
import React, { ReactNode } from "react";
import { useVisibility } from "../../hooks/useVisibility";
import { SecondaryButton } from "./SecondaryButton";

interface InlineConfirmDeletePopoverProps {
    children: ReactNode;
    placement?: string;
    confirmButtonText?: string;
    appendTo?: any;
    offset?: number[];
    onConfirm: (e?: any) => void;
}

export const InlineConfirmDeletePopover = ({
    children,
    placement = "bottom",
    confirmButtonText = "Confirm Delete",
    appendTo,
    offset,
    onConfirm,
}: InlineConfirmDeletePopoverProps) => {
    const [visible, { toggle, hide }] = useVisibility(false);

    const handleDelete = (e?: any) => {
        onConfirm(e);
        hide();
    };

    const handleClick = (e: any) => {
        e?.stopPropagation();
        toggle();
    };

    const handleHide = (e: any) => {
        e?.stopPropagation();
        hide();
    };

    return (
        <Popover visible={visible} offset={offset} placement={placement} appendTo={appendTo} onClickOutside={hide}>
            <span onClick={handleClick}> {children}</span>
            <Popover.Content className="space-x-2 p-2">
                <SecondaryButton onClick={handleHide}>Cancel</SecondaryButton>
                <Button data-testid="inline-confirm-delete" color="danger" onClick={handleDelete}>
                    {confirmButtonText}
                </Button>
            </Popover.Content>
        </Popover>
    );
};
